export default __webpack_public_path__ + "static/media/WhatsApp Community_National.cecffac6.png";